/*
 * @Author: huangzeshen
 * @Date: 2025-09-04 15:04:20
 * @LastEditors: huangzeshen
 * @LastEditTime: 2025-09-08 18:53:30
 * @FilePath: /waton-mobile/src/utils/eventTrack.EXC.js
 * @Description: 
 */
/*
* H5与原生之间的埋点通信功能
* @param eventName 事件名称
* @param params 事件参数
*/
export function eventTracking(eventName, params) {
  console.log('测试埋点', eventName, params);

  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
  let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

  if (isAndroid && window.jsInterface) {  //安卓设备
    if (window.jsInterface.eventTracking) {
      window.jsInterface.eventTracking(eventName, JSON.stringify(params || {}));
    } else {
      console.warn('Android原生未提供eventTracking方法');
    }
  } else if (isiOS && window.webkit && window.webkit.messageHandlers) {  //IOS设备
    if (window.webkit.messageHandlers.eventTracking) {
      window.webkit.messageHandlers.eventTracking.postMessage(JSON.stringify({
        "eventName": eventName,
        "params": params
      }));
    } else {
      console.warn('iOS原生未提供eventTracking方法');
    }
  } else {  //其他设备或未在app环境中
    console.log('埋点事件:', eventName, '参数:', params);
  }
}